<script>
    import SortableTable from '../../SortableTable.svelte';
    import ReferencesField from '../../../Forms/CustomFields/ReferencesField.svelte';
    import ReferenceLibraryField from '../../../Forms/CustomFields/ReferenceLibraryField.svelte';

    export let controls;

    export let selected_controls = [];

    let sortFields = [
        {
            field: "control_number",
            label: "Control Number"
        },
        {
            field: "name",
            label: "Control Title"
        },
        {
            field: 'topic_tags',
            label: "Topic Tags",
            type: "tags"
        },
        {
            field: "reference_library",
            label: "References",
            component: ReferenceLibraryField,
            componentProps: {
                readOnly: true
            },
            filterFunc: (filter, item)  => {
                if (filter == "") return true;
                if (!item["reference_library"]) return false;

                for (let reference of item["reference_library"]) {
                    let combined_references = `${reference.framework} ${reference.control}`;
                    if (combined_references.toLowerCase().includes(filter.toLowerCase())) {
                        return true
                    }
                }
                return false;
            }
        }
    ]

    function toggle(control_id) {
        let idx = selected_controls.indexOf(control_id)

        if (idx == -1) {
            selected_controls = [...selected_controls, control_id]
        } else {
            selected_controls = selected_controls.filter(item => control_id != item);
        }
    }

    export let cancelAction;
    export let saveAction;
</script>

<div class="modal is-active">
    <div class="modal-background" on:click={cancelAction}></div>
    <div class="modal-card is-fullwidth">
        <header class="modal-card-head">
            <p class="modal-card-title">Map Control</p>
            <span class="delete" aria-label="close" on:click|preventDefault={cancelAction}></span>
        </header>
        <section class="modal-card-body is-fullwidth">
            <SortableTable tableData={controls} {sortFields} ORM=true>
                <div slot="rowActions" class="has-text-centered" let:row={control}>
                    <input type="checkbox" value={control.id} checked={selected_controls.includes(control.id)} on:change={() => toggle(control.id)}>
                </div>
            </SortableTable>
        </section>
        <footer class="modal-card-foot buttons is-right">
            <button class="button is-success" on:click={() => saveAction(selected_controls)}>Map Selected</button>
        </footer>
    </div>
</div>